import { useMutation } from '@tanstack/react-query';
import { useManageComercialTableStore } from '../ManageComercialTable.store';
import { useCreateComercialTableStore } from '../../CreateComercialTable/CreateComercialTable.store';
import * as service from '../services';

export const useComercialProductDetailingList = () => {
  const { comercialTablePriceLimitAndRules } = useManageComercialTableStore();

  const { setCreateComercialTableBodyObj } = useCreateComercialTableStore();

  const getComercialTableProductList = async (id: number) => {
    const params = {
      page: 0,
      size: 1000,
      idTabelaComercial: id,
      descricao: [],
      familia: [],
      tier: [],
    };

    if (id) {
      const resp = await service.getComercialTableProducts(params);
      return resp;
    }
  };

  const actionSuccess = data => {
    setCreateComercialTableBodyObj(comercialTablePriceLimitAndRules, data.data.content);
  };

  const mutation = useMutation({
    mutationFn: (id: number) => getComercialTableProductList(id),
    onSuccess: actionSuccess,
  });

  return {
    handleGetComercialEditData: mutation.mutate,
  };
};
